import styled from "styled-components";

const ProductInfo = styled.div`
  padding: 16px;
  text-align: center;

`;
export default ProductInfo;